import { api } from "../api";

export interface DashboardFilters {
  startDate: Date;
  endDate: Date;
  userIds?: number[];
  providenceIds?: number[];
  clientId?: number | undefined;
  pdcId?: number | undefined;
  granularity?: 'day' | 'week' | 'month';
}

export interface DashboardSummary {
  totalActivities: number;
  avgExecutionTime: number;  // horas
  avgTotalTime: number;       // horas
  completionRate: number;     // 0-100
  overdueActivities: number;
  overduePercentage: number;
}

export interface TimeSeriesData {
  date: string;  // ISO date
  count: number;
}

export interface ResponsibleData {
  userName: string;
  userId: number;
  count: number;
  avgExecutionTime: number;
  completionRate: number;
}

export interface ProvidenceData {
  providenceId: number;
  providenceName: string;
  count: number;
  avgExecutionTime: number;
  avgTotalTime: number;
}

export interface ClientData {
  clientId: number;
  clientName: string;
  count: number;
}

export interface PdcData {
  pdcId: number;
  pdcName: string;
  count: number;
}

export interface DashboardStatsResponse {
  summary: DashboardSummary;
  timeSeries: TimeSeriesData[];
  byResponsible: ResponsibleData[];
  byProvidence: ProvidenceData[];
  byClient: ClientData[];
  byPdc: PdcData[];
}

/**
 * Busca estatísticas de atividades para o dashboard
 */
export const getActivitiesStats = async (filters: DashboardFilters): Promise<DashboardStatsResponse> => {
  const params = new URLSearchParams();
  
  params.append('startDate', filters.startDate.toISOString());
  params.append('endDate', filters.endDate.toISOString());
  
  if (filters.userIds && filters.userIds.length > 0) {
    params.append('userIds', filters.userIds.join(','));
  }
  
  if (filters.providenceIds && filters.providenceIds.length > 0) {
    params.append('providenceIds', filters.providenceIds.join(','));
  }
  
  if (filters.clientId) {
    params.append('clientId', filters.clientId.toString());
  }
  
  if (filters.pdcId) {
    params.append('pdcId', filters.pdcId.toString());
  }
  
  if (filters.granularity) {
    params.append('granularity', filters.granularity);
  }
  
  const { data } = await api.get<DashboardStatsResponse>(`/dashboard/activities-stats?${params}`);
  return data;
};

